import React from "react";

const ClaimsTableIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.75 9.16667H19.25M9.16667 2.75V19.25M2.75 4.58333C2.75 4.0971 2.94315 3.63079 3.28697 3.28697C3.63079 2.94315 4.0971 2.75 4.58333 2.75H17.4167C17.9029 2.75 18.3692 2.94315 18.713 3.28697C19.0568 3.63079 19.25 4.0971 19.25 4.58333V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V4.58333Z"
                stroke="#007BFF"
                stroke-width="1.83333"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default ClaimsTableIcon;
